// extracted by mini-css-extract-plugin
module.exports = {"back-homes":"RecentHomesBackLink_back-homes__37EtC"};